// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero_wrapper__KAnoJ","content":"hero_content___1Lo6","svg":"hero_svg__SM1vU","blob":"hero_blob__pOz0f","form":"hero_form__HFz_z","success":"hero_success__HyZa4"};